import * as R from 'ramda';
import { isNullOrUndefined } from 'util';

const filterNullNumbers = (values: number[]) => values.filter(value => !isNullOrUndefined(value));

export const parseNumber = (value: string) => (isNullOrUndefined(value)) ? null : +value;

export const round = (value: number, decimals: number = null) => (!isNullOrUndefined(value)) ? +value.toFixed(decimals) : null;

export const roundUp = Math.ceil;

export const compare = (a: number, b: number) => a - b;

export const getModule = (value: number, maxValue: number, reverse = false) => {
  return (reverse) ? maxValue - (value % maxValue) - 1 : value % maxValue;
};

export const sum = (a: number, b: number) => a + b;

export const isDivisibleBy = R.curry((base: number, value: number) => value % base === 0);

export const isEven = (value: number) => isDivisibleBy(2, value);

export const isNumeric = (value: string) => !isNaN(parseNumber(value));

export const min = (...values: number[]) => Math.min(...filterNullNumbers(values));

export const max = (...values: number[]) => Math.max(...filterNullNumbers(values));



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/utils/number.utils.ts